import ApiService from "../api";
import {encryptEmpfat} from '../EncriptService.js';

class BilheteService extends ApiService{

    constructor(){
        super('/portal/bilhete')
    }

    listar(filtro){
        console.log(filtro)
        return this.post('/getBilhetes', encryptEmpfat(filtro))
    }
}

export default BilheteService;